export default __webpack_public_path__ + "static/media/about-left-image.9f5a3a93.png";